module.exports = __webpack_public_path__ + "img/user.8208e472.png";